export default __webpack_public_path__ + "static/media/money.f08cbbe4.jpg";